import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { quizAPI } from '../services/api';
import { FiLogOut, FiUser, FiBook, FiTrendingUp, FiAward, FiMenu, FiX, FiSettings, FiClock, FiShoppingCart } from 'react-icons/fi';
import { API_BASE_URL, BASE_URL } from '../config/config';
const Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const [settings, setSettings] = useState({});
  const [stats, setStats] = useState({
    total_quizzes: 0,
    average_score: 0,
    best_score: 0,
    recent_quizzes: []
  });
  const [loading, setLoading] = useState(true);
  const fetchSiteSettings = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/site-settings`);
      const data = await response.json();
      if (data.success) {
        setSettings(data.data);
      }
    } catch (error) {
      console.error('Error fetching site settings:', error);
    }
  };

  useEffect(() => {
    fetchUserStats();
    fetchSiteSettings();
  }, []);

  const fetchUserStats = async () => {
    try {
      const response = await quizAPI.getUserStats(user.id);
      if (response.data.success) {
        setStats(response.data.stats);
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const statsData = [
    { 
      icon: FiBook, 
      label: 'Quizzes Taken', 
      value: stats.total_quizzes, 
      color: 'bg-blue-500',
      textColor: 'text-blue-500'
    },
    { 
      icon: FiTrendingUp, 
      label: 'Average Score', 
      value: `${stats.average_score}%`, 
      color: 'bg-green-500',
      textColor: 'text-green-500'
    },
    { 
      icon: FiAward, 
      label: 'Best Score', 
      value: `${stats.best_score}%`, 
      color: 'bg-purple-500',
      textColor: 'text-purple-500'
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
          
            {console.log("settings", settings)}
            <Link to="/" className="flex items-center space-x-2">
            {settings?.logo ? (
              <>
                <img 
                  src={`${BASE_URL}/${settings.logo}`}
                  alt={settings.site_name || 'Logo'}
                  className="h-10 w-auto"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.querySelector('.fallback-logo').style.display = 'flex';
                  }}
                />
                <div className="fallback-logo w-10 h-10 bg-gradient-to-br from-primary-500 to-purple-600 rounded-lg items-center justify-center" style={{ display: 'none' }}>
                  {/* <span className="text-white font-bold text-xl">R</span> */}
                </div>
              </>
            ) : (
              <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-purple-600 rounded-lg flex items-center justify-center">
                {/* <span className="text-white font-bold text-xl">R</span> */}
              </div>
            )}
            {/* <div className="hidden sm:block">
              <h1 className="text-xl font-bold text-gray-800">
                {settings?.site_name || 'Raj Economics'}
              </h1>
              <p className="text-xs text-gray-500">
                {settings?.site_tagline || 'RECC'}
              </p>
            </div> */}
          </Link>


            {/* Mobile Menu Button */}
            <button
              onClick={() => setShowMenu(!showMenu)}
              className="md:hidden p-2 rounded-lg hover:bg-gray-100"
            >
              {showMenu ? <FiX className="w-6 h-6" /> : <FiMenu className="w-6 h-6" />}
            </button>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-4">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary-500 to-secondary-500 flex items-center justify-center text-white font-semibold text-lg">
                  {user?.firstname?.[0]}{user?.lastname?.[0] || user?.firstname?.[1]}
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-700">
                    {user?.firstname} {user?.lastname}
                  </p>
                  <p className="text-xs text-gray-500">{user?.email}</p>
                </div>
              </div>
              <Link to="/profile" className="p-2 rounded-lg hover:bg-gray-100 transition-colors">
                <FiSettings className="w-5 h-5 text-gray-600" />
              </Link>
              <button
                onClick={handleLogout}
                className="btn-secondary !py-2 !px-4 text-sm"
              >
                <FiLogOut className="inline mr-2" />
                Logout
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {showMenu && (
            <div className="md:hidden mt-4 pt-4 border-t">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary-500 to-secondary-500 flex items-center justify-center text-white font-semibold text-lg">
                  {user?.firstname?.[0]}{user?.lastname?.[0] || user?.firstname?.[1]}
                </div>
                <div>
                  <p className="font-semibold text-gray-700">
                    {user?.firstname} {user?.lastname}
                  </p>
                  <p className="text-sm text-gray-500">{user?.email}</p>
                </div>
              </div>
              <div className="space-y-2">
                <Link
                  to="/profile"
                  className="block w-full text-left px-4 py-2 rounded-lg hover:bg-gray-100"
                  onClick={() => setShowMenu(false)}
                >
                  <FiSettings className="inline mr-2" />
                  Profile Settings
                </Link>
                <button
                  onClick={handleLogout}
                  className="btn-secondary w-full text-sm"
                >
                  <FiLogOut className="inline mr-2" />
                  Logout
                </button>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Welcome Section */}
        <div className="card mb-8 bg-gradient-to-r from-primary-500 to-secondary-500 text-white">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold mb-2">
                Welcome back, {user?.firstname}! 👋
              </h2>
              <p className="text-white/90">Ready to test your knowledge today?</p>
            </div>
            <Link
              to="/my-courses"
              className="mt-4 md:mt-0 bg-white text-primary-500 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
            >
              My Courses
            </Link>
          </div>
        </div>

        {/* Stats Grid */}
        {loading ? (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-primary-500 mx-auto"></div>
            <p className="text-gray-600 mt-4">Loading stats...</p>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
              {statsData.map((stat, index) => (
                <div key={index} className="card hover:shadow-xl transition-shadow cursor-pointer">
                  <div className="flex items-center">
                    <div className={`${stat.color} p-4 rounded-lg mr-4`}>
                      <stat.icon className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <p className="text-gray-500 text-sm">{stat.label}</p>
                      <p className={`text-2xl md:text-3xl font-bold ${stat.textColor}`}>
                        {stat.value}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Recent Quizzes */}
            {stats.recent_quizzes && stats.recent_quizzes.length > 0 && (
              <div className="card mb-8">
                <h3 className="text-xl font-bold text-gray-800 mb-4">Recent Results</h3>
                <div className="space-y-3">
                  {stats.recent_quizzes.map((quiz, index) => {
                    const isExam = quiz.type === 'exam';
                    return (
                      <div key={index} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                        <div className="flex items-center space-x-3 flex-1">
                          <FiClock className="text-gray-400" />
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2">
                              <p className="font-medium text-gray-700 truncate">
                                {isExam && quiz.exam_name ? quiz.exam_name : `Practice Quiz ${index + 1}`}
                              </p>
                              <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold flex-shrink-0 ${
                                isExam 
                                  ? 'bg-purple-100 text-purple-700' 
                                  : 'bg-blue-100 text-blue-700'
                              }`}>
                                {isExam ? '📝 Test' : '🎯 Quiz'}
                              </span>
                            </div>
                            <p className="text-sm text-gray-500">
                              {new Date(quiz.created_at).toLocaleDateString()}
                            </p>
                          </div>
                        </div>
                        <div className="text-right flex-shrink-0">
                          <p className={`text-lg font-bold ${
                            quiz.percentage >= 70 ? 'text-green-500' : 
                            quiz.percentage >= 50 ? 'text-yellow-500' : 
                            'text-red-500'
                          }`}>
                            {quiz.percentage}%
                          </p>
                          <p className="text-sm text-gray-500">
                            {quiz.correct_answers}/{quiz.total_questions}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <Link 
                  to="/history" 
                  className="block text-center text-primary-500 hover:text-primary-600 font-medium mt-4"
                >
                  View All History →
                </Link>
              </div>
            )}
          </>
        )}

        {/* Quick Actions */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Link to="/courses" className="card hover:shadow-xl transition-all group cursor-pointer">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-primary-500 transition-colors">
                  Browse Courses
                </h3>
                <p className="text-gray-600">Explore and purchase new courses</p>
              </div>
              <FiShoppingCart className="w-12 h-12 text-orange-500 group-hover:scale-110 transition-transform" />
            </div>
          </Link>

          <Link to="/my-courses" className="card hover:shadow-xl transition-all group cursor-pointer">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-primary-500 transition-colors">
                  My Courses
                </h3>
                <p className="text-gray-600">Access your purchased courses and test series</p>
              </div>
              <FiBook className="w-12 h-12 text-primary-500 group-hover:scale-110 transition-transform" />
            </div>
          </Link>

          <Link to="/history" className="card hover:shadow-xl transition-all group cursor-pointer">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-primary-500 transition-colors">
                  Quiz History
                </h3>
                <p className="text-gray-600">View your past quiz results</p>
              </div>
              <FiTrendingUp className="w-12 h-12 text-green-500 group-hover:scale-110 transition-transform" />
            </div>
          </Link>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;

